import React from 'react';
import { Scales, X } from '@phosphor-icons/react';

export const CompareModal = ({ isOpen, onClose, comparison }) => {
  if (!isOpen || !comparison) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-5xl bg-white dark:bg-[#0F172A] border-2 border-black dark:border-white shadow-[8px_8px_0px_#000] dark:shadow-[8px_8px_0px_#2B4C6F] my-8">
        <div className="p-4 border-b-2 border-black dark:border-white bg-amber-500 text-white flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Scales size={20} weight="fill" />
            <h3 className="font-black uppercase tracking-wide">Estimate Comparison</h3>
          </div>
          <button onClick={onClose} className="hover:bg-white/20 p-1 rounded"><X size={24} /></button>
        </div>
        
        <div className="p-6">
          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-neutral-100 dark:bg-neutral-800 p-4 border-2 border-black dark:border-white">
              <p className="text-xs text-neutral-500 uppercase tracking-widest">Avg. Low</p>
              <p className="text-2xl font-black text-neutral-900 dark:text-white font-mono">
                ${comparison.comparison?.average_low?.toLocaleString() || 0}
              </p>
            </div>
            <div className="bg-[#2B4C6F]/10 p-4 border-2 border-[#2B4C6F]">
              <p className="text-xs text-[#2B4C6F] uppercase tracking-widest">Avg. Mid</p>
              <p className="text-2xl font-black text-[#2B4C6F] font-mono">
                ${comparison.comparison?.average_mid?.toLocaleString() || 0}
              </p>
            </div>
            <div className="bg-neutral-100 dark:bg-neutral-800 p-4 border-2 border-black dark:border-white">
              <p className="text-xs text-neutral-500 uppercase tracking-widest">Price Spread</p>
              <p className="text-2xl font-black text-neutral-900 dark:text-white font-mono">
                ${comparison.comparison?.price_spread?.toLocaleString() || 0}
              </p>
            </div>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full border-2 border-black dark:border-white">
              <thead>
                <tr className="bg-neutral-100 dark:bg-neutral-800 border-b-2 border-black dark:border-white">
                  <th className="p-3 text-left font-bold uppercase tracking-wider text-xs">Estimate</th>
                  <th className="p-3 text-left font-bold uppercase tracking-wider text-xs">Job Type</th>
                  <th className="p-3 text-left font-bold uppercase tracking-wider text-xs">Location</th>
                  <th className="p-3 text-right font-bold uppercase tracking-wider text-xs">Low</th>
                  <th className="p-3 text-right font-bold uppercase tracking-wider text-xs">Mid</th>
                  <th className="p-3 text-right font-bold uppercase tracking-wider text-xs">High</th>
                </tr>
              </thead>
              <tbody>
                {comparison.estimates?.map((est) => (
                  <tr key={est.id} className={`border-b border-neutral-200 dark:border-neutral-700 ${
                    est.id === comparison.comparison?.lowest_estimate?.id ? 'bg-emerald-50 dark:bg-emerald-900/20' :
                    est.id === comparison.comparison?.highest_estimate?.id ? 'bg-red-50 dark:bg-red-900/20' : ''
                  }`}>
                    <td className="p-3 font-bold text-neutral-900 dark:text-white">{est.name}</td>
                    <td className="p-3 text-neutral-600 dark:text-neutral-400 uppercase text-sm">{est.job_type?.replace('_', ' ')}</td>
                    <td className="p-3 text-neutral-600 dark:text-neutral-400">{est.location}</td>
                    <td className="p-3 text-right font-mono">${est.price_low?.toLocaleString()}</td>
                    <td className="p-3 text-right font-mono font-bold text-[#2B4C6F]">${est.price_mid?.toLocaleString()}</td>
                    <td className="p-3 text-right font-mono">${est.price_high?.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="mt-4 flex gap-4 text-xs text-neutral-500">
            <span className="flex items-center gap-1"><span className="w-3 h-3 bg-emerald-200 border border-emerald-500"></span> Lowest Mid Price</span>
            <span className="flex items-center gap-1"><span className="w-3 h-3 bg-red-200 border border-red-500"></span> Highest Mid Price</span>
          </div>
        </div>
      </div>
    </div>
  );
};
